import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

const index = new AxiosMockAdapter(instance);

const mockMeteringNodesList = [
  {
    id: 'bf8cc9ed-fb0b-4fef-a8ea-39bb4d268c45',
    typeId: 'type-1',
    typeName: 'Точка обліку',
    kindId: 'kind-1',
    kindName: 'Власний',
    locationTypeId: 'loc-1',
    locationTypeName: 'Житловий будинок',
    name: 'Вузол обліку №1',
    meteringPointId: null,
    commercialMeteringPointId: null,
  },
  {
    id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    typeId: 'type-2',
    typeName: 'Комерційна точка',
    kindId: 'kind-2',
    kindName: 'Орендований',
    locationTypeId: 'loc-2',
    locationTypeName: 'Комерційне приміщення',
    name: 'Вузол обліку №2',
    meteringPointId: null,
    commercialMeteringPointId: null,
  },
];

index
  .onGet(/\/api\/gas-metering-nodes\/query(?:\?.*)?$/)
  .reply(200, mockMeteringNodesList)
  .onGet(/\/api\/gas-metering-nodes\/([^/?]+)(?:\?.*)?$/)
  .reply(config => {
    const id = config.url?.match(/\/([^/?]+)(?:\?.*)?$/)?.[1];
    const node = mockMeteringNodesList.find(n => n.id === id);
    if (!node) return [200, null];
    return [
      200,
      {
        id: node.id,
        type: { id: node.typeId, type: 'type', value: node.typeName ?? '' },
        kind: { id: node.kindId, type: 'kind', value: node.kindName ?? '' },
        locationType: {
          id: node.locationTypeId ?? '',
          type: 'location',
          value: node.locationTypeName ?? '',
        },
        name: node.name ?? '',
        complexSystemNumber: 0,
        notCountConnectedPower: false,
        ourBalance: false,
        changeable: true,
        reverse: false,
        meteringPointId: node.meteringPointId ?? '',
        seasonType: { id: 'season-1', type: 'season', value: 'Опалювальний' },
        commercialMeteringPointId: node.commercialMeteringPointId ?? '',
      },
    ];
  })
  .onPost(/\/api\/gas-metering-nodes\/?$/)
  .reply(200, {})
  .onPut(/\/api\/gas-metering-nodes\/([^/?]+)(?:\?.*)?$/)
  .reply(200, {})
  .onAny()
  .passThrough();
